/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { BackupPolicyExpression } from '../models/BackupPolicyExpression';
import { ResourceSelectorMode } from '../models/ResourceSelectorMode';

export class BackupPolicyResourceSelector {
  'resourceSelectionMode': ResourceSelectorMode;
  'expression'?: BackupPolicyExpression | null;
  /**
  * List of cloud-provider-assigned resource IDs to include in the backup policy, regardless of whether they\'re excluded by `resourceSelectionMode` and `expression`. 
  */
  'resourceInclusionOverride'?: Array<string>;
  /**
  * List of cloud-provider-assigned resource IDs to exclude from the backup policy, regardless of whether they\'re included by `resourceSelectionMode` and `expression`. 
  */
  'resourceExclusionOverride'?: Array<string>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "resourceSelectionMode",
      "baseName": "resourceSelectionMode",
      "type": "ResourceSelectorMode",
      "format": ""
    },
    {
      "name": "expression",
      "baseName": "expression",
      "type": "BackupPolicyExpression",
      "format": ""
    },
    {
      "name": "resourceInclusionOverride",
      "baseName": "resourceInclusionOverride",
      "type": "Array<string>",
      "format": ""
    },
    {
      "name": "resourceExclusionOverride",
      "baseName": "resourceExclusionOverride",
      "type": "Array<string>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return BackupPolicyResourceSelector.attributeTypeMap;
  }

  public constructor() {
  }
}



